import { useCallback, useEffect, useRef, useState } from "react";
import { isBrowser } from "./utils/isBrowser";

export const useIntersectionObserver = <
  E extends Element | null | undefined = HTMLElement,
>(
  ref: React.RefObject<E>,
  options: IntersectionObserverInit = {},
) => {
  const [isIntersecting, setIsIntersecting] = useState<boolean>(false);
  const observer = useRef<IntersectionObserver>(null);
  const disconnect = useCallback(() => {
    observer?.current?.disconnect();
  }, []);

  useEffect(() => {
    if (!isBrowser) {
      return;
    }
    const element = ref.current;
    if (!element) {
      return;
    }
    observer.current = new IntersectionObserver((entries) => {
      /* istanbul ignore next */
      if (!entries.length) {
        return;
      }
      setIsIntersecting(entries[0].isIntersecting);
    }, options);

    observer.current.observe(element);
    return () => {
      disconnect();
    };
  }, [disconnect, options, ref]);

  return { isIntersecting, disconnect };
};
